import type { RankedPath } from '../../../api/siteAnalyticsApi';
import type { Simulation } from '../../../api/simulationsApi';
import { sectionOf, type RankedRow } from '../shared/rankedRows';

export const pageRows = (paths: RankedPath[]): RankedRow[] => paths.map(p => ({
  key: p.path, label: p.path, users: p.users, visits: p.visits, events: p.events,
  search: p.path.toLowerCase(),
  facets: { section: [sectionOf(p.path)] },
}));

/** `cbse:10` → `CBSE 10`, `jee` → `JEE`. */
export const boardGradeLabel = (k: string) => k.split(':').map(p => (/^\d+$/.test(p) ? p : p.toUpperCase())).join(' ');
export const cap = (s: string) => s.charAt(0).toUpperCase() + s.slice(1);

/** Joined to the catalogue for its title, subject, audience and status — which
 *  a simulation's traffic cannot say about itself. A simulation the catalogue
 *  does not know keeps its id and matches no catalogue filter. */
export const simulationRows = (paths: RankedPath[], catalog: Map<string, Simulation>): RankedRow[] => paths.map(p => {
  const id = p.entityId ?? p.path;
  const sim = catalog.get(id);
  const facets: RankedRow['facets'] = sim
    ? { subject: [sim.subject], boardGrade: sim.boardGrades ?? [], status: [sim.status] }
    : {};
  return {
    key: id, label: sim?.title ?? id, ...(sim ? { sub: id } : {}),
    users: p.users, visits: p.visits, events: p.events,
    search: `${id} ${sim?.title ?? ''}`.toLowerCase(),
    facets,
  };
});


/** A referrer's kind, collapsed for the table filter: every `other:<host>` is
 *  one "Other" choice — each host is already its own row. */
export const referrerFacet = (kind?: string) => (!kind ? [] : kind.startsWith('other:') ? ['other'] : [kind]);
